import { render, staticRenderFns } from "./TourHome.vue?vue&type=template&id=b07716d8&lang=pug&"
import script from "./TourHome.vue?vue&type=script&lang=js&"
export * from "./TourHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports